// removed by extract-text-webpack-plugin
module.exports = {"repTitle":"RepresentativeList--repTitle--3b9ZWDRL","repName":"RepresentativeList--repName--1ml33MbO","activityList":"RepresentativeList--activityList--1sUZwAUN","voterVoice":"RepresentativeList--voterVoice--4Ea7rr5w"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/Onboarding/Steps/Representatives/RepresentativeList.css
// module id = 1301
// module chunks = 2